module.exports = __webpack_public_path__ + "img/iconePedidosFinalizado.aa264201.png";